import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useToasts } from "react-toast-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from 'react-redux';
import { updateShowVerificationR } from '../../../redux/actions';

const PVerificationModal = ({ show, setShowVerification, updateShowVerification }) => {
    const { addToast } = useToasts();
    const userInformation = JSON.parse(localStorage.getItem("user"));
    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);

    const handleClose = () => {
        setIsSent(false);
        updateShowVerification(false);
        setShowVerification(false);
    };

    const handleResendEmail = async () => {
        setIsLoading(true);
        await axios
            .post(`/api/email/resend`)
            .then((response) => {
                console.log({ response });
                setIsSent(true);
            })
            .catch((error) => {
                console.log({ error });
                addToast("Unable to send verification email", {
                    appearance: "error",
                    autoDismiss: true,
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        userInformation && (
            <Modal
                show={show}
                onHide={() => updateShowVerification(false)}
                className="modalThankYou"
                centered
            >
                <Modal.Body>
                    <div className="text-center sendtip-wrapper">
                        <button className="close" style={{ top: 10 }} onClick={handleClose}>X</button>
                        {isSent && (
                            <p className="pt-4" style={{ fontSize: 45 }}>
                                <FontAwesomeIcon
                                    icon={["fas", "check-circle"]}
                                    size="lg"
                                    className="text-success"
                                />
                            </p>
                        )}
                        <h6 className={`${isSent ? '' : 'pt-4'}`}>
                            {isSent
                                ? 'Verification email sent!'
                                : 'Verify your account'
                            }
                        </h6>
                        <p className="mt-3 mb-4" style={{ padding: '0px 80px' }}>
                            {isSent
                                ? 'A verification mail has been sent to your email account. Please check your inbox to verify.'
                                : 'To proceed with any further purchases, please follow the link to verify your account.'
                            }
                        </p>
                        {!isSent && (
                            <div id="sendtipform">
                                <div className="btns clearfix">
                                    <button
                                        onClick={handleResendEmail}
                                        className="btn btn-default sendtip blue-btn-hover"
                                        disabled={isLoading}>
                                        <FontAwesomeIcon
                                            icon={["fas", "envelope"]}
                                            size="lg"
                                            className="mr-2 text-secondary text-light"
                                        />
                                        {isLoading ? "Sending email..." : "Verify Email"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        )
    );
};

function mapStateToProps(state) {
    return {
        showVerification: state.message.showVerification,
    };
}

function mapDispatchToProps(dispatch) {
    //return bindActionCreators({updateMute}, dispatch)
    return {
        updateShowVerification: (showVerification) => dispatch(updateShowVerificationR(showVerification)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PVerificationModal);